var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"act-marquee",style:(_vm.wrapStyle)},[_c('transition',{attrs:{"name":"fade"}},_vm._l((_vm.records),function(item,index){return (index === _vm.current_show)?_c('div',{key:index,domProps:{"innerHTML":_vm._s(item)}}):_vm._e()}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561e5f0d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigUI/ActMarquee.vue
// module id = null
// module chunks = 